

























































































































































































































































































































































import {Vue, Component, Watch} from "vue-property-decorator";
import { Action, Mutation, State } from "vuex-class";
import getConnection from "@/utils/signalr_connection";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";

@Component
export default class NavBar extends ComponentBaseMixin {
    @State("user") userInfo;
    @State menuCollapsed;

    messages = {
        count: 0,
        notifications: [],
    };

    connectedUsers = {
        online: 0,
        users: [],
    };

    @Action("logout") logoutUser: () => void;
    @Mutation setMenuCollapsed;
    online = true;

    async created() {
      const connection = getConnection();
      this.online = connection.state != 'Disconnected';
      connection.onclose(() => this.online = false);
      connection.onreconnected(() => this.online = true);
      setInterval(() => console.log(connection.state), 5000);
      connection.on('receivedMessageFromAgent', this.loadNotifications);
      connection.on('userConnected', () => this.loadMobileUsers());
      connection.on('userDisconnected', () => this.loadMobileUsers());
      connection.on('updatedReadMessages', () => this.loadNotifications());
      await this.loadNotifications();
      await this.loadMobileUsers();
    }

    checkSidebar() {
      if (this.menuCollapsed) {
        this.setMenuCollapsed(false);
      } else {
        this.setMenuCollapsed(true);
      }
    }

    async loadNotifications() {
      const { data } = await this.axios.get("/api/GetNotifications");
      this.messages = data;
    }

    async loadMobileUsers() {
      const { data } = await this.axios.get("/api/GetMobileUsers");
      this.connectedUsers = {
        online: data.filter(x => x.online).length,
        users: data
      };
    }

    async logout() {
        await this.logoutUser();
        return await this.$router.push("/login");
    }

    @Watch("online")
    onlineChanged(isOnline) {
      if (isOnline) {
        this.showInfo("Komunikacija sa agentima je uspostavljena");
      } else {
        this.showError("Izbubljena komunikacija sa agentima! Učitajte stranicu ponovo");
      }
    }

  destroyed() {
    const connection = getConnection();
    connection.off(this.loadNotifications);
    connection.off('userConnected');
    connection.off('userDisconnected');
    connection.off('updatedReadMessages');
  }
}
